module.exports = __webpack_public_path__ + "static/media/bg-chicken-guarantee.ba164cb9.jpg";